import { registerComponent } from './actions';
import { createPlugin, primaryToolbarPluginKey } from './pm-plugin';
import Separator from './ui/separator';
export var primaryToolbarPlugin = function primaryToolbarPlugin() {
  // We use a plugin variable to store the component registry to avoid having to use
  // effects in each plugin, and to enable rendering the toolbar in SSR
  // TODO: Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
  var componentRegistry = new Map();

  // Pre-fill registry with the separator component
  componentRegistry.set('separator', Separator);
  return {
    name: 'primaryToolbar',
    actions: {
      registerComponent: registerComponent(componentRegistry)
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'primaryToolbar',
        plugin: function plugin() {
          return createPlugin(componentRegistry);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return;
      }
      return primaryToolbarPluginKey.getState(editorState);
    }
  };
};